<template>
  <div id="logindiv" class="pclogin">
    <div id="login">
      <h3 style="margin-bottom:20px">
        <span>{{ webname }}</span>
      </h3>
      <el-row class="margin-large-bottom">
        <el-input prefix-icon="el-icon-user" type="text" v-model="tel" placeholder="请输入账号或手机号码" />
      </el-row>
      <el-row class="margin-large-bottom">
        <el-input prefix-icon="el-icon-key" type="password" v-model="password" placeholder="请输入密码" @keyup.enter.native="submitForm" />
      </el-row>
      <el-row class="margin-large-bottom text-center">
        <el-button type="primary" @click="submitForm">登录</el-button>
        <!-- <el-button type='text' @click="$router.push('/wxlogin')" class="margin-big-left"><img style='height:30px;position:absolute;top:50%;margin-top:-15px;' src='/static/images/wechat.png' /></el-button> -->
        <el-button type='text' @click="wxLoginDiv=true" class="margin-big-left" v-if="terminal=='pc'" ><img style='height:30px;position:absolute;top:50%;margin-top:-15px;' src='/static/images/wechat.png'/></el-button>
        <el-button type='text' @click="goMobileLogin" class="margin-big-left" v-else><img style='height:30px;position:absolute;top:50%;margin-top:-15px;' src='/static/images/wechat.png'/></el-button>
      </el-row>
      <!-- <el-row class="margin-large-bottom text-center" v-if='terminal=="mobile"'>
        <el-button type='primary' @click='goMobile'>访问web版</el-button>
      </el-row> -->
      <el-row class="margin-large-bottom text-center">
      </el-row>
    </div>
    <div class="text-center" style="position:absolute;bottom:0;width:100%;">
      <a :href="beianurl" class="margin-right" :style="beiancolor_text" v-if="beian!=''">{{beian}}</a><a :href="gonganbeianurl" :style="beiancolor_text" v-if="gonganbeian!=''"><img v-if="gonganico!=''" height="20px" :src="gonganico">{{gonganbeian}}</a>
    </div>
    <el-dialog :visible.sync="wxLoginDiv" :show-close="false" :close-on-click-modal="false" width="400px">
      <wxlogin appid="wxa683e4cddbe2097c" scope="snsapi_login" theme="black" :redirect_uri='encodeURIComponent("http://auth.qlsww.com/openreceive/openoa")' rel="external nofollow"> </wxlogin>
      <div slot="footer" class="dialog-footer">
        <el-button @click="wxLoginDiv = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import wxlogin from "vue-wxlogin";
export default {
  data() {
    return {
      tel: "",
      password: "",
      beian: "",
      beianurl: "",
      gonganbeian: "",
      gonganbeianurl: "",
      gonganico: "",
      beiancolor: "#fff",
      webname: window.webName,
      wxLoginDiv:false
    };
  },
  components: {
    wxlogin,
  },
  mounted() {
    // this.request();
  },
  computed: {
    terminal() {
      if (
        /Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(
          navigator.userAgent
        )
      ) {
        return "mobile";
      } else {
        return "pc";
      }
    },
    beiancolor_text() {
      return "color:" + this.beiancolor;
    },
  },
  methods: {
    getinfo() {
      this.$axios({
        url: this.HOST + "/employee/login/getinfo",
        method: "get",
        data: {},
      }).then((res) => {
        if (res.data.status == 1) {
          sessionStorage.setItem("webname", res.data.webname);
          this.webname = res.data.webname;
          this.beian = res.data.beian;
          this.beianurl = res.data.url;
          this.gonganbeian = res.data.gonganbeian;
          this.gonganbeianurl = res.data.gonganbeian_url;
          this.gonganico = res.data.gongan_ico;
          this.beiancolor = res.data.beiancolor;
        }
      });
    },
    submitForm() {
      if (this.tel == "") {
        this.$message({
          type: "error",
          message: "请输入手机号或账号",
        });
        return;
      }
      if (this.password == "") {
        this.$message({
          type: "error",
          message: "请输入密码",
        });
        return;
      }
      this.$axios({
        method: "post",
        url: this.HOST + "/employee/login/login",
        data: {
          account: this.tel,
          password: this.password,
          terminal:this.terminal
        },
      }).then((res) => {
        // console.log(res);
        if (res.data.status == 1) {
          sessionStorage.setItem("employeeuuid", res.data.employeeinfo.uuid);
          sessionStorage.setItem("employeename", res.data.employeeinfo.name);
          sessionStorage.setItem("employeetoken", res.data.token);
          sessionStorage.setItem("employeeislogin", true);
          sessionStorage.setItem(
            "sectionlist",
            JSON.stringify(res.data.sectionlist)
          );
          this.$router.push("/index");
        }
      });
    },
    goMobile(){
      window.location.href = window.webHOST;
    },
    goMobileLogin(){
      window.location.href = '/mobile'
    }
  },
  created() {
    this.getinfo();
    sessionStorage.removeItem("menulist");
  },
};
</script>

